import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import '@/shared/styles/fonts.css'
import './index.css'
import '@/shared/utils/apiKeyConfig'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
